<template>
  <div class="main">
    <div v-if="$cookies.get('auth_grade') > 80">
      <HR24 />
    </div>
    <div class="jiazaishuju">
      <el-button
        v-if="['80', '60'].indexOf($cookies.get('auth_grade')) == -1"
        type="warning"
        size="mini"
        @click="
          is_view = true;
          is_views();
        "
      >
        详细数据
      </el-button>
    </div>
    <!-- <Company /> -->
    <div v-if="is_view">
      <div class="alldata" v-if="$cookies.get('auth_grade') == 90">
        <div class="all_chart">
          <div id="chart1" style="width: 100%; height: 258px"></div>
          <div
            id="chart2"
            style="width: 100%; height: 258px; margin-top: 37px"
          ></div>
          <div
            id="chart3"
            style="width: 100%; height: 258px; margin-top: 50px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
          <div
            id="chart4"
            style="width: 100%; height: 258px; margin-top: 50px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
          <div
            id="echa"
            style="width: 100%; height: 258px; margin-top: 42px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
        </div>
        <div class="all_data">
          
          <div class="data data1">
            <h3>
              今日数据
              <el-date-picker
                style="width: 130px; margin-left: 6px"
                v-model="copy_date"
                type="date"
                placeholder="请选择复制数据的日期"
                @change="copyText_date"
                :clearable="false"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                type="primary"
                class="copybtn"
                ref="copybtn"
                style="margin-right: 6px"
                v-if="$cookies.get('auth_grade') > 80"
                size="mini"
                @click="copyText"
                :disabled="is_copyText"
                :data-clipboard-text="copy_value"
                >{{ !is_copyText ? "复制数据" : "加载中..." }}</el-button
              >
            </h3>
            <div class="item_conent">
              <div
                @click="linkDate(item)"
                v-for="(item, index) in data2"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/seed.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data">
            <h3>
              用户数据
              <el-date-picker
                style="width: 130px; margin-left: 6px"
                @change="all_data_change"
                v-model="all_data_date"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker>
            </h3>

            <div class="item_conent" v-loading="all_data_loading">
              <div
                class="item_data"
                v-for="(item, index) in data1"
                :key="index"
                @click="linkDate(item, all_data_date)"
              >
                <img src="/static/img/icon/data.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>
              简历数据分布
              <!-- <el-date-picker
                style="width: 130px; margin-left: 6px"
                @change="data3_change"
                v-model="data3_date"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker> -->
            </h3>
            <div class="item_conent" v-loading="data3_loading">
              <div
                @click="data3Click(item)"
                v-for="(item, index) in data3"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/resume.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>简历线索数据分布</h3>
            <div class="item_conent" v-loading="data3_loading">
              <div
                v-for="(item, index) in radar_data"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/xiansuo.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>30日数据</h3>
            <div class="item_conent">
              <div
                @click="linkDate_mon(item, false)"
                v-for="(item, index) in data_mon"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/yysj-jjfzgl02.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="agent_data"
        v-if="
          $cookies.get('auth_grade') == 60 || $cookies.get('auth_grade') == 80
        "
      >
        <div class="data">
          <h3 style="width: 100%">用户数据</h3>
          <div class="item_conent">
            <div
              class="item_data"
              v-for="(item, index) in agent_data"
              :key="index"
              @click="linkDate(item)"
            >
              <img src="/static/img/icon/data.png" alt />
              <div class="cursor">
                <div>{{ item.title }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <h3 style="width: 100%">简历和雷达数据</h3>
          <div class="item_conent">
            <div
              class="item_data"
              v-for="(item, index) in agent_resume_data"
              :key="index"
              @click="linkDate(item)"
            >
              <img src="/static/img/icon/resume.png" alt />
              <div class="cursor">
                <div>{{ item.title }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <h3 style="width: 100%">今日数据</h3>
          <div class="item_conent">
            <div
              class="item_data"
              v-for="(item, index) in agent_login_data"
              :key="index"
              @click="linkDate(item)"
            >
              <img src="/static/img/icon/seed.png" alt />
              <div class="cursor">
                <div>{{ item.title }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alldata" v-if="$cookies.get('auth_grade') == 100">
        <div class="all_chart">
          <div id="chart1" style="width: 100%; height: 258px"></div>
          <div
            id="chart2"
            style="width: 100%; height: 258px; margin-top: 37px"
          ></div>
          <div
            id="chart3"
            style="width: 100%; height: 258px; margin-top: 50px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
          <div
            id="chart4"
            style="width: 100%; height: 258px; margin-top: 50px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
          <div
            id="echa"
            style="width: 100%; height: 258px; margin-top: 42px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
          <div
            id="chart5"
            style="width: 100%; height: 258px; margin-top: 45px"
            v-if="$cookies.get('auth_grade') > 80"
          ></div>
        </div>
        <div class="all_data">
          
          <div class="data data1">
            <h3>
              今日数据

              <el-date-picker
                style="width: 130px; margin-left: 6px"
                v-model="copy_date"
                type="date"
                placeholder="请选择复制数据的日期"
                @change="copyText_date"
                :clearable="false"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                type="primary"
                class="copybtn"
                ref="copybtn"
                style="margin-right: 6px"
                v-if="$cookies.get('auth_grade') > 80"
                size="mini"
                @click="copyText"
                :disabled="is_copyText"
                :data-clipboard-text="copy_value"
                >{{ !is_copyText ? "复制数据" : "加载中..." }}</el-button
              >
            </h3>
            <div class="item_conent">
              <div
                @click="linkDate(item)"
                v-for="(item, index) in data2"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/seed.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data">
            <h3>
              用户数据<el-date-picker
                style="width: 130px; margin-left: 6px"
                @change="all_data_change"
                v-model="all_data_date"
                :disabled="isdisabled"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker>
            </h3>
            <div class="item_conent" v-loading="all_data_loading">
              <div
                class="item_data"
                v-for="(item, index) in data1"
                :key="index"
                @click="linkDate(item, all_data_date)"
              >
                <img src="/static/img/icon/data.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>
              简历数据分布
              <!-- <el-date-picker
                style="width: 130px; margin-left: 6px"
                @change="data3_change"
                v-model="data3_date"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker> -->
            </h3>
            <div class="item_conent" v-loading="data3_loading">
              <div
                @click="data3Click(item)"
                v-for="(item, index) in data3"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/resume.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>简历线索数据分布</h3>
            <div class="item_conent" v-loading="data3_loading">
              <div
                v-for="(item, index) in radar_data"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/xiansuo.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>30日数据</h3>
            <div class="item_conent">
              <div
                @click="linkDate_mon(item, false)"
                v-for="(item, index) in data_mon"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/yysj-jjfzgl02.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>精英版30日数据</h3>
            <div class="item_conent">
              <div
                v-for="(item, index) in data_mon_eli"
                @click="linkDate_mon(item, true)"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/yysj-rydw01.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import Clipboard from "clipboard";
import HR24 from "@/components/daData/hr24";
// import Company from '@/components/index/company'

export default {
  components: { HR24 },
  data() {
    return {
      all_data_loading: false,
      data3_loading: false,
      copy_date: new Date(),
      all_data_date: "",
      data3_date: "",
      data1: [],
      data2: [],
      data_mon: [
        {
          title: "30日登录",
          value: 0,
          type: "login_in_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "30日简历下载",
          value: 0,
          type: "down_resume_count",
          id: 1,
          src: "download_resume",
        },
        {
          title: "30日新增用户",
          value: 0,
          type: "create_user_count",
          id: 1,
          src: "create_user",
        },
        {
          title: "30日完善简历",
          value: 0,
          type: "setting_resume_count",
          id: 1,
          src: "setting_resume",
        },
        {
          title: "30日投递简历",
          value: 0,
          type: "send_resume_count",
          id: 1,
          src: "send_resume",
        },
        {
          title: "30日添加JD",
          value: 0,
          type: "create_jd_count",
          id: 2,
          src: "create_jd",
        },
        {
          title: "30日完善公司",
          value: 0,
          type: "setting_company_count",
          id: 0,
          src: "setting_company",
        },
        // {
        //   title: '30日签到',
        //   value: 0,
        //   type: 'sign_in_count',
        //   id: 0,
        //   src: 'sign_in',
        // },
        {
          title: "30日雷达线索",
          value: 0,
          type: "radar_count",
          id: 1,
          src: "radar_list",
        },
      ],
      data_mon_eli: [
        {
          title: "精英版30日登录",
          value: 0,
          type: "login_in_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "精英版今日登录",
          value: 0,
          type: "login_in_count",
          id: 0,
          src: "login_in",
        },
      ],
      data3: [],
      resumedata3: [],
      radarData: [],
      radar_data: [],

      all_place_data: [],
      seed_place_data: [],
      resume_count_city: [],
      radar_count: [],
      city_radar: 0,
      setting_resume_count: 0,
      big_resume_count: 0,
      small_resume_count: 0,
      agent_data: [
        {
          title: "用户总数",
          value: 0,
          type: "all_counts",
          src: "all_company",
        },
        {
          title: "正常用户",
          value: 0,
          type: "user_counts",
          src: "use_company",
        },
        {
          title: "到期用户",
          value: 0,
          type: "past_due_counts",
          src: "pass_due_company",
        },
        {
          title: "付费用户",
          value: 0,
          type: "agent_pay_user_count",
          src: "pay_company",
        },
        {
          title: "充值用户",
          value: 0,
          type: "agent_seed_user_count",
          src: "send_company",
        },
        {
          title: "体验用户",
          value: 0,
          type: "agent_experience_user_count",
          src: "experience_company",
        },
      ],
      agent_resume_data: [
        {
          //能点击详情时    加   is_is:true
          title: "城市总简历",
          value: 0,
          type: "all_resume_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "简历总数",
          value: 0,
          type: "all_agent_resume_count",
          src: "all_agent_resume",
        },
        {
          title: "城市线索总数",
          value: 0,
          type: "all_clue_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "线索总数",
          value: 0,
          type: "all_agent_clue_count",
          src: "all_agent_clue",
        },
      ],
      agent_login_data: [
        {
          title: "今日登录",
          value: 0,
          type: "login_in_count",
          src: "login_in",
        },
        {
          title: "今日完善简历",
          value: 0,
          type: "setting_resume_count",
          src: "",
          is_is: true,
        },
        {
          title: "今日投递简历",
          value: 0,
          type: "send_resume_count",
          src: "send_resume",
        },
        {
          title: "今日添加JD",
          value: 0,
          type: "create_jd_count",
          src: "create_jd",
        },
        {
          title: "今日完善公司",
          value: 0,
          type: "setting_company_count",
          src: "setting_company",
        },
        {
          title: "今日雷达线索",
          value: 0,
          type: "resume_radar_count",
          src: "radar_list",
        },
      ],
      is_copyText: true,
      copy_value: "",
      is_view: false,
    };
  },

  created() {
    if (["80", "60"].indexOf(this.$cookies.get("auth_grade")) != -1) {
      this.agent_day_detail();
      this.is_view = true;
      this.is_views();
    }
  },

  methods: {
    agent_day_detail() {
      let obj = {
        username: this.$cookies.get("agent_username") || "",
        show_data: "experience_company",
        search_data: {},
        page: 0,
      };
      require("post", "/hr24_index_data/v1/agent_day_detail/", obj).then(
        (res) => {
          console.log("鑫泽", res.data);
          if (!res.code) {
            if (
              res.data.return_data.length > 0 &&
              Number(this.$cookies.get("experience_count") || 0) <
                res.data.experience_count
            ) {
              console.log("鑫泽");
              this.$confirm(`您有体验用户，是否查看`, "提示", {
                confirmButtonText: "前往查看",
                cancelButtonText: "我知道了",
                type: "warning",
              })
                .then(() => {
                  this.$cookies.set(
                    "experience_count",
                    res.data.experience_count
                  );
                  this.$router.push({
                    path: "company",
                    query: {
                      src: "experience_company",
                    },
                  });
                })
                .catch(() => {
                  this.$cookies.set(
                    "experience_count",
                    res.data.experience_count
                  );
                });
            }
          }
        }
      );
    },

    all_data_change() {
      this.isdisabled = true
      this.data3_change()
      this.all_data_loading = true;
      var data1_url = "";
      if (this.$cookies.get("auth_grade") == 100) {
        data1_url = "/hr24_index_data/v1/home_info/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        data1_url = "/hr24_index_data/v1/province_agent_home_page/";
      }
      require("post", data1_url, {
        search_year: this.all_data_date.getFullYear(),
      }).then((res) => {
        if (!res.code) {
          this.data1.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop] || 0;
          });
          this.agent_data.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop];
          });
          this.all_place_data = res.data.all_place_data;

          this.seed_place_data = res.data.pay_place_data;
          this.all_data_loading = false;
          if (this.$cookies.get("auth_grade") > 80) {
            this.getEchartData1();
            this.getEchartData2();
          }
        }
      });
    },

    data3_change() {
      this.data3_loading = true;
      var data1_url = "";
      if (this.$cookies.get("auth_grade") == 100) {
        data1_url = "/hr24_index_data/v1/resume_count_city/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        data1_url = "/hr24_index_data/v1/province_agent_resume_data/";
      }
      require("post", data1_url, {
        search_year: this.all_data_date.getFullYear(),
      }).then((res) => {
        if (!res.code) {
          this.resume_count_city = res.data.city_list;
          this.radar_count = res.data.radar_count;
          console.log(this.resume_count_city);
          this.isdisabled = false
          if (
            this.$cookies.get("auth_grade") == 100 ||
            this.$cookies.get("auth_grade") == 90
          ) {
            this.getEchartData3();
            this.radar_dataEchartData();
            this.data3_loading = false;
          }
        }
      });
    },

    is_views() {
      this.init(); //初始化数据
      let data1_url = ""; //数值data1数据接口,页面右侧第一种
      let data2_url = ""; //数值data2数据接口,页面右侧第二种
      let obj = {};
      var date = new Date();
      let year = date.getFullYear(); //获取完整的年份(4位)
      let mouth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      let day = date.getDate(); //获取当前日(1-31)
      mouth = mouth >= 10 ? mouth : "0" + mouth;
      day = day >= 10 ? day : "0" + day;
      let datenew = year + "-" + mouth + "-" + day;
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        data1_url = "/hr24_index_data/v1/agent_home_page/";
        data2_url = "/hr24_index_data/v1/agent_data/";
        obj.username = this.$cookies.get("agent_username") || "";
      } else if (this.$cookies.get("auth_grade") == 90) {
        data1_url = "/hr24_index_data/v1/province_agent_home_page/";
        data2_url = "/hr24_index_data/v1/province_agent_day_statistics/";
      } else {
        data1_url = "/hr24_index_data/v1/home_info/";
        data2_url = "/hr24_index_data/v1/day_data/";
      }
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        require("post", "/hr24_index_data/v1/agent_day_statistics/", obj).then(
          (res) => {
            if (!res.code) {
              this.agent_login_data.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
              });
            }
          }
        );
      }
      // if (this.$cookies.get('auth_grade') == 100) {
      //   require('post', '/hr24_index_data/v1/province_agent_day_statistics/', obj).then(
      //     (res) => {
      //       if (!res.code) {
      //         this.agent_login_data.map((item, index) => {
      //           let prop = item.type
      //           item.value = res.data[prop]
      //         })
      //       }
      //     }
      //   )
      // }

      require("post", data1_url, obj).then((res) => {
        if (!res.code) {
          this.data1.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop] || 0;
          });
          this.agent_data.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop];
          });
          this.all_place_data = res.data.all_place_data;

          this.seed_place_data = res.data.pay_place_data;

          if (this.$cookies.get("auth_grade") > 80) {
            this.getEchartData1();
            this.getEchartData2();
          }
        }
      });

      require("post", data2_url, obj).then((res) => {
        if (!res.code) {
          if (
            this.$cookies.get("auth_grade") == 100 ||
            this.$cookies.get("auth_grade") == 90
          ) {
            this.cash_data = res.data.cash_data;
            this.data2.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop] || 0;
            });
          } else {
            this.agent_resume_data.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop] || 0;
            });
          }
        }
      });

      if (this.$cookies.get("auth_grade") == 90) {
        require("post", "/hr24_index_data/v1/province_agent_resume_data/", obj).then(
          (res) => {
            if (!res.code) {
              this.resume_count_city = res.data.city_list;
              this.radar_count = res.data.radar_count;
              console.log(this.resume_count_city);
              if (this.$cookies.get("auth_grade") == 90) {
                this.getEchartData3();
                this.radar_dataEchartData();
              }
            }
          }
        );
        this.getEchartData4();
        require("post", "/hr24_index_data/v1/province_agent_month_all_count/", obj).then(
          (res) => {
            if (!res.code) {
              this.data_mon.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
                return item;
              });
            }
          }
        );

        this.copyText_date(datenew);
        require("post", "/hr24_index_data/v1/province_agent_month_day_detail/", {
          show_data: "login_in",
        }).then((res) => {
          if (!res.code) {
            let mon_data = res.data.splice(",").map((item) => {
              return item;
            });
            var myChart = this.$echarts.init(document.getElementById("echa"));
            this.showLine(myChart, mon_data, res.time_list, "30日登录");
          }
        });
      }
      if (this.$cookies.get("auth_grade") == 100) {
        require("post", "/hr24_index_data/v1/month_all_count_elite/", obj).then(
          (res) => {
            console.log(res, "123");
            if (!res.code) {
              this.data_mon_eli[0].value = res.data.login_in_count;
            }
          }
        );

        require("post", "/hr24_index_data/v1/month_all_count/", obj).then(
          (res) => {
            if (!res.code) {
              // console.log(res, "月总数");
              this.data_mon.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
              });
            }
          }
        );
        require("post", "/hr24_index_data/v1/resume_count_city/", obj).then(
          (res) => {
            if (!res.code) {
              this.resume_count_city = res.data.city_list;
              this.radar_count = res.data.radar_count;
              console.log(this.resume_count_city);
              if (
                this.$cookies.get("auth_grade") == 100 ||
                this.$cookies.get("auth_grade") == 90
              ) {
                this.getEchartData3();
                this.radar_dataEchartData();
              }
            }
          }
        );
        if (
          this.$cookies.get("auth_grade") == 100 ||
          this.$cookies.get("auth_grade") == 90
        ) {
          this.getEchartData4();
        }

        let obj_m = {
          show_data: "login_in",
        };

        require("post", "/hr24_index_data/v1/month_day_detail/", obj_m).then(
          (res) => {
            if (!res.code) {
              let mon_data = res.data.splice(",").map((item) => {
                return item;
              });
              var myChart = this.$echarts.init(document.getElementById("echa"));
              this.showLine(myChart, mon_data, res.time_list, "30日登录");
            }
          }
        );
        this.copyText_date(datenew);
      }
    },
    copyText_date(e) {
      console.log("e", e);
      this.is_copyText = true;
      let obj = {
        date: e,
      };
      if (this.$cookies.get("auth_grade") == 100) {
        require("post", "/hr24_index_data/v1/today_data/", obj).then((res) => {
          if (!res.code) {
            let text = "";
            for (let key in res.data) {
              text += key + ":" + res.data[key] + ",";
            }
            console.log(text);
            this.copy_value = text;
            this.is_copyText = false;
          } else {
            this.$message.error("复制出错");
          }
        });
      } else {
        require("post", "/hr24_index_data/v1/province_agent_today_data/", obj).then(
          (res) => {
            if (!res.code) {
              let text = "";
              for (let key in res.data) {
                text += key + ":" + res.data[key] + ",";
              }
              console.log(text);
              this.copy_value = text;
              this.is_copyText = false;
            } else {
              this.$message.error("复制出错");
            }
          }
        );
      }
    },
    copyText() {
      var _this = this;
      this.$nextTick(() => {
        console.log(this.copy_value, "cas");
        // console.log("aca", this.$refs.copybtn.$el.);
        var clipboard = new Clipboard(".copybtn");
        clipboard.on("success", (e) => {
          console.log("cjbsajbcas");
          this.$message.success("复制成功");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          this.$message.error("不支持复制");
          // tips(this, '该浏览器不支持自动复制!', 'warning')
          // 释放内存
          clipboard.destroy();
        });
      });
    },
    init() {
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        this.data1 = [
          {
            title: "用户总数",
            value: 0,
            type: "all_counts",
            src: "all_company",
          },
          {
            title: "到期数量",
            value: 0,
            type: "past_due_counts",
            src: "pass_due_company",
          },
          {
            title: "正常用户",
            value: 0,
            type: "use_counts",
            src: "use_company",
          },
          {
            title: "简历总数",
            value: 0,
            type: "big_resume_count",
            src: "big_resume_count",
          },
          {
            title: "线索总数",
            value: 0,
            type: "small_resume_count",
            src: "small_resume_count",
          },
          {
            title: "充值用户",
            value: 0,
            type: "agent_seed_user_count",
            src: "agent_seed_user_count",
          },
          {
            title: "体验用户",
            value: 0,
            type: "agent_experience_user_count",
            src: "agent_experience_user_count",
          },
          {
            title: "付费用户",
            value: 0,
            type: "agent_pay_user_count",
            src: "agent_pay_user_count",
          },
        ];
        this.data2 = [
          {
            title: "今日登录",
            value: 0,
            type: "login_in_count",
            id: 0,
            src: "login_in",
          },
          {
            title: "今日简历下载",
            value: 0,
            type: "download_count",
            id: 1,
            src: "download_resume",
          },
          {
            title: "今日完善简历",
            value: 0,
            type: "setting_resume_count",
            id: 1,
            src: "setting_resume",
          },
          {
            title: "今日投递简历",
            value: 0,
            type: "send_resume_count",
            id: 1,
            src: "send_resume",
          },
          {
            title: "今日添加JD",
            value: 0,
            type: "create_jd_count",
            id: 2,
            src: "create_jd",
          },

          {
            title: "今日雷达线索",
            value: 0,
            type: "resume_radar_count",
            id: 1,
            src: "radar_list",
          },
        ];
      } else {
        this.data1 = [
          {
            title: "用户总数",
            value: 0,
            type: "all_counts",
            src: "all_company",
          },
          {
            title: "到期数量",
            value: 0,
            type: "past_due_counts",
            src: "pass_due_company",
          },
          {
            title: "正常用户",
            value: 0,
            type: "use_counts",
            src: "use_company",
          },
          {
            title: "简历总数",
            value: 0,
            type: "big_resume_count",
            src: "big_resume_count",
            is_is: true,
          },
          {
            title: "线索总数",
            value: 0,
            type: "small_resume_count",
            src: "small_resume_count",
            is_is: true,
          },
          {
            title: "充值客户",
            value: 0,
            type: "seed_user_count",
            src: "seed_user",
          },
          {
            title: "体验客户",
            value: 0,
            type: "experience_user_count",
            src: "experience_user",
          },
          {
            title: "付费客户",
            value: 0,
            type: "pay_user_count",
            src: "pay_user",
          },
          // {
          //   title: "礼金数",
          //   value: 0,
          //   type: "cash_data",
          //   src: "cash_data"
          // }
        ];
        this.data2 = [
          {
            title: "今日登录",
            value: 0,
            type: "login_in_count",
            id: 0,
            src: "login_in",
          },
          {
            title: "今日简历下载",
            value: 0,
            type: "download_count",
            id: 1,
            src: "download_resume",
          },
          {
            title: "今日完善简历",
            value: 0,
            type: "setting_resume_count",
            id: 1,
            src: "setting_resume",
          },
          {
            title: "今日投递简历",
            value: 0,
            type: "send_resume_count",
            id: 1,
            src: "send_resume",
          },
          {
            title: "今日添加JD",
            value: 0,
            type: "create_jd_count",
            id: 2,
            src: "create_jd",
          },
          {
            title: "今日完善公司",
            value: 0,
            type: "setting_company_count",
            id: 0,
            src: "setting_company",
          },
          // {
          //   title: "今日签到",
          //   value: 0,
          //   type: "sign_in_count",
          //   id: 0,
          //   src: "sign_in"
          // },
          {
            title: "今日雷达线索",
            value: 0,
            type: "resume_radar_count",
            id: 1,
            src: "radar_list",
          },
        ];
      }
    },
    showLine(myChart, mon_data, day, text) {
      myChart.setOption({
        title: {
          text: text,
          textStyle: {
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: day,
        },
        yAxis: {},
        label: {},
        tooltip: {},
        series: [{ name: "数量", type: "line", data: mon_data }],
      });
    },
    // 精英版折线
    getEchartData4() {
      let obj_data = { show_data: "login_in" };
      require("post", "/hr24_index_data/v1/month_day_detail_elite/", obj_data).then(
        (res) => {
          if (!res.code) {
            console.log(res, "shuju");
            var myChart = this.$echarts.init(document.getElementById("chart5"));
            this.data_mon_eli[1].value = res.data[res.data.length - 1];
            this.showLine(myChart, res.data, res.time_list, "精英版30日登录");
          } else {
          }
        }
      );
    },

    open_cash() {
      let s = "";
      for (let i in this.cash_data) {
        s += this.cash_data[i].company_name + " ";
        s += this.cash_data[i].compant_place_data + " ";
        s += this.cash_data[i].cash_gift_sum + " ";
        s += "/\r\n";
      }

      this.$alert(s),
        {
          confirmButtonText: "确定",
          callback: (action) => {},
        };
    },

    linkDate(e, date) {
      console.log(date);
      if (e.is_is) {
        // this.$message.warning("暂不开放");
        return false;
      }
      console.log(e);
      // 礼金记录打开小
      if (e.type == "cash_data") {
        this.open_cash();
        return;
      }
      let arr = [
        "resume_radar_count",
        "small_resume_count",
        "big_resume_count",
      ];
      if (date == "" || date == undefined) {
        if (this.$cookies.get("auth_grade") != 90) {
          this.$router.push({ path: "/company", query: { src: e.src } });
          return false;
        } else {
          if (arr.indexOf(e.type) == -1) {
            this.$router.push({ path: "/company", query: { src: e.src } });
            return false;
          } else {
            if (e.type == "resume_radar_count") {
              this.$router.push({ path: "/rader_agent_S" });
            }
          }
        }
      }else{
        if (this.$cookies.get("auth_grade") != 90) {
          this.$router.push({ path: "/company", query: { src: e.src,date:date.getFullYear() } });
          return false;
        } else {
          if (arr.indexOf(e.type) == -1) {
            this.$router.push({ path: "/company", query: { src: e.src,date:date.getFullYear()  } });
            return false;
          } else {
            if (e.type == "resume_radar_count") {
              this.$router.push({ path: "/rader_agent_S" });
            }
          }
        }
      }
    },
    data3Click(e) {
      console.log(e);
      // if (e.title && this.$cookies.get("auth_grade") != 90) {
      this.$router.push({
        path: "/city",
        query: { src: e.title, date: this.data3_date?this.data3_date.getFullYear():'' },
      });
      // }
    },
    linkDate_mon(e, name) {
      console.log(name);
      if (e.src) {
        this.$router.push({
          path: "/line_ech",
          query: { src: e.src, title: e.title, name: name },
        });
      }
    },
    getEchartData1() {
      let arr1 = [];
      let arr = [];
      for (let i in this.all_place_data) {
        arr.push(this.all_place_data[i]);
        arr1.push(i);
      }

      var myChart = this.$echarts.init(document.getElementById("chart1"));
      var text = "用户地区分布";
      this.setOption(myChart, arr, arr1, text);
    },
    getEchartData2() {
      let arr = [];
      let arr1 = [];
      for (let i in this.seed_place_data) {
        arr.push(this.seed_place_data[i]);
        arr1.push(i);
      }

      var myChart = this.$echarts.init(document.getElementById("chart2"));
      var text = "付费用户地区分布";

      this.setOption(myChart, arr, arr1, text);
    },

    getEchartData3() {
      let arr = [];
      let arr1 = [];
      this.big_resume_count = 0
      for (let i in this.resume_count_city) {
        this.big_resume_count += this.resume_count_city[i];
        // console.log(i)
        arr.push(this.resume_count_city[i]);
        arr1.push(i);
      }
      // 简历总数总据
      this.data1[3].value = this.big_resume_count;
      var myChart = this.$echarts.init(document.getElementById("chart3"));
      var text = "简历地区分布";
      this.setOption(myChart, arr, arr1, text);

      // big 简历数据 对应数据，8个
      let eigth_arr = [];
      let eigth_arr_title = [];
      if (this.$cookies.get("auth_grade") == 90) {
        eigth_arr = arr;
        eigth_arr_title = arr1;
        console.log("90权限打印", eigth_arr, eigth_arr_title);
      } else {
        eigth_arr = arr.splice(0, 8);
        eigth_arr_title = arr1.splice(0, 8);
      }
      console.log(eigth_arr, eigth_arr_title);
      this.data3 = [];
      for (let i = 0; i < eigth_arr.length; i++) {
        this.data3.push({
          title: eigth_arr_title[i],
          value: eigth_arr[i],
        });
      }
    },

    // 简历线索数据
    radar_dataEchartData() {
      let arr = [];
      let arr1 = [];
      this.small_resume_count = 0;
      for (let i in this.radar_count) {
        this.small_resume_count += this.radar_count[i];
        arr.push(this.radar_count[i]);
        arr1.push(i);
      }

      // 简历总数总据
      this.data1[4].value = this.small_resume_count;
      var myChart = this.$echarts.init(document.getElementById("chart4"));
      var text = "简历线索地区分布";
      this.setOption(myChart, arr, arr1, text);
      console.log(arr, arr1);

      // big 简历数据 对应数据，8个
      let eigth_arr = [];
      let eigth_arr_title = [];
      if (this.$cookies.get("auth_grade") == 90) {
        eigth_arr = arr;
        eigth_arr_title = arr1;
      } else {
        eigth_arr = arr.splice(0, 8);
        eigth_arr_title = arr1.splice(0, 8);
      }
      this.radar_data = [];
      for (let i = 0; i < eigth_arr.length; i++) {
        this.radar_data.push({
          title: eigth_arr_title[i],
          value: eigth_arr[i],
        });
      }
    },

    // 柱状图
    setOption(myChart, arr, arr1, text) {
      // console.log(myChart, arr, arr1, text);
      if (text == "用户地区分布") {
        var color = "rgba(159, 194, 248, 0.8)";
      }
      if (text == "充值用户地区分布") {
        var color = "rgba(51, 212, 144, 0.8)";
      }
      if (text == "简历地区分布") {
        var color = "rgba(73, 151, 255, 0.8)";
      }
      if (text == "简历线索地区分布") {
        var color = "rgba(239, 112, 46, 0.8)";
      }
      myChart.setOption({
        title: {
          text: text,
          textStyle: {
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        tooltip: {},
        xAxis: {
          data: arr1,
        },
        yAxis: {},
        series: [
          {
            name: "人数",
            type: "bar",
            data: arr,
            color: color,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.data3 {
  /* margin-top: 16px;
  height: 220px; */
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  padding-top: 10px;
}

.main {
  margin-top: 46px;
  background: #ffff;
  border-radius: 4px;
  padding: 50px;
  min-height: 90vh;
}

.alldata {
  display: flex;
}

.all_chart {
  width: 50%;
}

.chart {
  width: 100%;
  display: flex;
  height: 230px;
  align-items: center;
  margin-bottom: 100px;
}

.all_data {
  width: 50%;
  z-index: 200;
}
.item_conent {
  width: calc(100% - 24px);
  height: 224px;
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  overflow: auto;
  background: #f7f7f7;
  border-radius: 12px;
}
.item_data {
  display: flex;
  position: relative;
  z-index: 999;
  height: 100px;
}

.data {
  width: 100%;
}
.data > h3 {
  width: 100%;
  padding: 0 0 12px 0;
  border-bottom: #bdbdbd solid 1px;
}

img {
  height: 30px;
  widows: 30px;
  margin-right: 10px;
  z-index: 200;
}

.data > .item_conent > div {
  margin-right: 30px;
  width: 20%;
}

.item_data div:first-child {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
}
.item_data div:last-child {
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.agent_data {
  position: relative;
  z-index: 10;
}
.kong {
  text-align: center;
}
.jiazaishuju {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/index/index.vue